import { render, staticRenderFns } from "./yyxx.vue?vue&type=template&id=52720adf&scoped=true&"
import script from "./yyxx.vue?vue&type=script&lang=js&"
export * from "./yyxx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52720adf",
  null
  
)

export default component.exports